import {
    Box,
    Text,
    Flex,
    Spinner,
    useDisclosure
} from '@chakra-ui/react'
import styled from 'styled-components'
import { colors } from 'src/common/colors'
import ActionButton from '../../components/common/ActionButton'
import ClubInfo from 'src/components/common/ClubInfo'
import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import ErrorPage from '../error-page'
import useGetClubDetails from "src/hooks/SearchInfo/useGetClubDetails"
import usePutClubStatus from 'src/hooks/ManageClubJoin/usePutClubStatus'
import SModal from 'src/components/common/SModal'
import SToast from 'src/components/common/SToast'

export default function ClubDetails() {
    const { clubId } = useParams<{ clubId: string }>()
    const { getClubDetails, academy, clubDetailsError } = useGetClubDetails()
    const { putClubStatus, clubStatusError } = usePutClubStatus()
    const navigate = useNavigate()
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { errorToast, successToast } = SToast()

    const {
        isOpen: isActivateModalOpen,
        onOpen: onActivateModalOpen,
        onClose: onActivateModalClose
    } = useDisclosure()

    const {
        isOpen: isDeleteModalOpen,
        onOpen: onDeleteModalOpen,
        onClose: onDeleteModalClose
    } = useDisclosure()

    useEffect(() => {
        if (clubId) {
            getClubDetails(clubId)
        }
    }, [clubId])

    const handleClubStatusChange = async (id: string, active: boolean) => {
        try {
            await putClubStatus(id)
            navigate(-1)
            successToast(`클럽을 성공적으로 ${active === true ? '비활성화' : '활성화'} 하였습니다.`)
        } catch (error) {
            console.error('An error occurred:', error)
            errorToast()
        }
    }

    return (
        <Container>
            <Flex justifyContent='space-between' marginBottom='24px'>
                <Text fontFamily='KFAGothicBold' fontSize='22px' color={colors.darkBlue}>검색 결과 상세</Text>
                <Box>
                    {academy && clubId && academy.active === true ?
                        <>
                            <ActionButton
                                backgroundColor={colors.button.red}
                                _hover={{ bg: 'hover.red', color: 'white' }}
                                width='117px'
                                height='44px'
                                marginRight='9px'
                                text='휴면 전환'
                                onClick={onOpen}
                            />
                            <SModal
                                title='휴면 전환'
                                desc='정말로 비활성화 하시겠습니까?'
                                onClick={() => handleClubStatusChange(clubId, academy.active)}
                                isOpen={isOpen}
                                onOpen={onOpen}
                                onClose={onClose}
                            />
                        </>
                        :
                        academy && clubId && academy.active === false ?
                            <Box>
                                <>
                                    <ActionButton
                                        backgroundColor={colors.button.blue}
                                        _hover={{ bg: 'hover.blue', color: 'white' }}
                                        width='117px'
                                        height='44px'
                                        marginRight='9px'
                                        text='활성화 하기'
                                        onClick={onActivateModalOpen}
                                    />
                                    <SModal
                                        title='활성화 하기'
                                        desc='정말로 활성화 하시겠습니까?'
                                        onClick={() => handleClubStatusChange(clubId, academy.active)}
                                        isOpen={isActivateModalOpen}
                                        onOpen={onActivateModalOpen}
                                        onClose={onActivateModalClose}
                                        color={'blue'}
                                    />
                                </>
                                <>
                                    <ActionButton
                                        backgroundColor={colors.button.red}
                                        _hover={{ bg: 'hover.red', color: 'white' }}
                                        width='117px'
                                        height='44px'
                                        marginRight='9px'
                                        text='삭제하기'
                                        onClick={onDeleteModalOpen}
                                    />
                                    {/* <SModal
                                        title='삭제하기'
                                        desc='정말로 삭제 하시겠습니까?'
                                        onClick={() => 
                                        isOpen={isDeleteModalOpen}
                                        onOpen={onDeleteModalOpen}
                                        onClose={onDeleteModalClose}
                                        color={'red'}
                                    /> */}
                                </>
                            </Box>
                            :
                            clubStatusError ?
                                <Box>
                                    <ErrorPage />
                                </Box>
                                :
                                <Box>
                                    <Spinner />
                                </Box>
                    }
                </Box>
            </Flex>
            {(clubId && academy) ?
                <ClubInfo club={academy} />
                :
                !clubId ?
                    <Text color={colors.darkBlue}>Club ID not found</Text>
                    :
                    clubDetailsError ?
                        <Box>
                            <ErrorPage />
                        </Box>
                        :
                        <Box>
                            <Spinner />
                        </Box>
            }
        </Container>
    )
}

const Container = styled.div`
    width: calc(100vw - 506px);
    min-width: 850px;
    margin-right: 92px;
`